export const skybitzContent = (
  <>
    <div className="prose dark:prose-invert max-w-none">
      <p>
        The improved portal now features BI Dashboards that offer quick, visual
        snapshots of low-level tanks, product demand, and overall delivery
        efficiency.
      </p>
      <p>
        Users can view, sort, and filter tanks by any parameter with an
        interactive display. The interface offers essential KPIs for monitoring
        activities, meeting targets, and maximizing savings. A customizable grid
        view also shows key tank metrics like current gallons, available
        capacity, volume percentage, temperatures, signal strength, and battery
        level.
      </p>
    </div>
  </>
);
